import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepOtherInsuranceCoverageTugo = (state) => state.get('stepOtherInsuranceCoverageTugo');

const makeSelectStepOtherInsuranceCoverageTugo = () => createSelector(
  selectStepOtherInsuranceCoverageTugo,
  (stepState) => ({
    hasProvincialHealthCoverage: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'hasProvincialHealthCoverage']),
      'false'
    ),
    provincialHealthProvince: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'provincialHealthProvince']),
      ''
    ),
    hasOtherInsuranceCoverage: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'hasOtherInsuranceCoverage']),
      'false'
    ),
    otherInsuranceCoverageTypes: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'otherInsuranceCoverageTypes']),
      []
    ),
    employerInsuranceCompany: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'employerInsuranceCompany']),
      ''
    ),
    employerPolicyGroupNo: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'employerPolicyGroupNo']),
      ''
    ),
    creditCardProvider: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'creditCardProvider']),
      ''
    ),
    creditCardFirst4Digits: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'creditCardFirst4Digits']),
      ''
    ),
    creditCardLast4Digits: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'creditCardLast4Digits']),
      ''
    ),
    creditCardInsuranceProvider: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'creditCardInsuranceProvider']),
      ''
    ),
    anotherTravelInsuranceCompany: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'anotherTravelInsuranceCompany']),
      ''
    ),
    anotherTravelPolicyNumber: mapWithDefault(
      stepState,
      () => stepState.getIn(['form', 'anotherTravelPolicyNumber']),
      ''
    ),
  })
);

const makeSelectStepOtherInsuranceCoverageTugoErrors = () =>
  createSelector(selectStepOtherInsuranceCoverageTugo, (state) => state.get('errors'));

export {
  makeSelectStepOtherInsuranceCoverageTugo,
  makeSelectStepOtherInsuranceCoverageTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOtherInsuranceCoverage/selectors.js